













import { Component, Mixins, Prop } from "vue-property-decorator";
import { ObjectSelectableContentMixin } from "./mixins";
import { default as WizardContentCheckSelectorOption } from "./WizardContentCheckSelectorOption.vue";

@Component({
  components: {
    WizardContentCheckSelectorOption,
  }
})
export default class WizardContentCheckSelector extends Mixins(ObjectSelectableContentMixin) {
  @Prop()
  scale: number;
}
